import { useRecordActions } from '@/features/RecordActions/model/useRecordActions';
import { UserTableToolbar } from '@/shared/ui/UserTableToolbar/UserTableToolbar';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ApiMessageTemplateGroup } from '@/core/generated/api';
import { RoutePath } from '@/core/config/routeConfig';
import { useMessageTemplateStore } from '@/entities/MessageTemplate/model/store';
import { MESSAGE_TEMPLATE_COLUMNS } from '@/entities/MessageTemplate/config/messageTemplate-table.config';
import { BackButton } from '@/shared/ui/BackButton/BackButton';
import { DataTable } from '@/shared/ui/DataTable/DataTable';
import { RequestEmpty, RequestErrorBanner } from '@/shared/ui/RequestState';
import { RequestStatus } from '@/shared/model/requestStatus';

/** Показывает сообщения выбранной группы */
export const MessageTemplateGroupPage = () => {
    const recordActions = useRecordActions('messageTemplates', () => selectedGroup
        ? fetchGroup(selectedGroup)
        : undefined);

    const { group } = useParams<{ group: string }>();
    const selectedGroup = Object.values(ApiMessageTemplateGroup).find((value) => value === group);
    const { groups, items, activeGroup, listStatus, listError, fetchGroups, fetchGroup, reset } = useMessageTemplateStore();
    const navigate = useNavigate();

    useEffect(() => {
        if (!selectedGroup || selectedGroup === ApiMessageTemplateGroup.Undefined) return;
        void fetchGroups();
        void fetchGroup(selectedGroup);

        return reset;
    }, [selectedGroup, fetchGroups, fetchGroup, reset]);

    if (!selectedGroup || selectedGroup === ApiMessageTemplateGroup.Undefined) {
        return <RequestEmpty message="Группа не найдена" />;
    }

    const title = groups.find((item) => item.id === selectedGroup)?.name ?? 'Текстовки группы';

    return (
        <main>
            <h1>{title}</h1>
            <RequestErrorBanner
                status={listStatus}
                error={listError}
                fallbackMessage="Не удалось загрузить текстовки"
                onRetry={() => fetchGroup(selectedGroup)}
            />
            <DataTable
                rowActions={recordActions.getMenuItems}
                getRowUrl={item => item.id
                    ? `/message-templates/${encodeURIComponent(item.id)}/edit`
                    : undefined}
                header={<UserTableToolbar
                    createButton={<BackButton url={RoutePath.messageTemplates} />}
                />}
                data={activeGroup === selectedGroup
                    ? items
                    : []
                }
                columns={MESSAGE_TEMPLATE_COLUMNS}
                loading={listStatus === RequestStatus.Loading}
                onRowClick={(item) => {
                    if (item.id) navigate(RoutePath.messageTemplateEdit.replace(':id', item.id));
                }}
            />
            {recordActions.dialogs}
        </main>
    );
};
